import React from 'react';
import './Category.css';
import Image from '../shared/Image';
import { useNavigate } from 'react-router-dom';
import config from './../../config.json';
import preview from './../../public/image/preview2.png'


const Category = ({_id, imgSrc, name }) => {
    const navigate = useNavigate();
    return (
        <div className='category-card' onClick={() => navigate('/products', {state: {categoryId: _id, categoryName: name}})}>
            <div>
                <Image
                    src={imgSrc ? `${config.api_address}/upload/${imgSrc}` : preview}
                    width={window.innerWidth < 576 ? 140 : 180}
                    height={window.innerWidth < 576 ? 105 : 135}
                    style={{objectFit: 'cover', opacity: imgSrc ? '1' : '.5'}}
                    borderRadius={'10px 10px 2px 2px'}
                />
                <div className='title'>
                    <div className=''>{name}</div>
                </div>
            </div>
        </div>
    );
}

export default Category;